<template>
    <InputNumber
        class="currency-input"
        v-model="inputValue"
        :inputId="id"
        :min="min"
        :max="max"
        :minFractionDigits="minFractionDigits"
        :maxFractionDigits="maxFractionDigits"
        mode="decimal"
        locale="en-CH"
        :disabled="disabled"
        @input="onInput"
        :inputProps="{
            inputmode: 'decimal',
        }"
    />
</template>

<script setup lang="ts">
    import { ref, watch } from "vue";

    import InputNumber, { type InputNumberInputEvent } from "primevue/inputnumber";

    const MAX_NUMBER = 9_999_999;

    // define props with default values
    const props = withDefaults(
        defineProps<{
            id?: string;
            disabled?: boolean;
            min?: number;
            max?: number;
            minFractionDigits?: number;
            maxFractionDigits?: number;
            modelValue: number | null;
        }>(),
        {
            id: `input-${new Date().getTime()}`,
            disabled: false,
            min: 0,
            minFractionDigits: 2,
            maxFractionDigits: 2,
            max: MAX_NUMBER,
        }
    );

    // define emits
    const emit = defineEmits(["update:modelValue"]);

    // define state
    const inputValue = ref(props.modelValue);

    // event handlers
    function onInput(e: InputNumberInputEvent) {
        inputValue.value = (e.value === undefined ? null : (e.value ?? 0)) as any;
    }

    watch(inputValue, (newValue) => {
        emit("update:modelValue", newValue);
    });

    // update watchers
    watch(
        () => props.modelValue,
        (newValue) => {
            inputValue.value = newValue;
        }
    );
</script>

<style lang="scss">
    @use "./../../../assets/styles/scss/shared/_colors.scss";

    .currency-input {
        input {
            text-align: right;
            color: colors.$fontColor;
            font-size: 24px !important;
            min-width: 100px;
            width: 250px;
            max-width: none;
            border-radius: 7px;
        }
    }
</style>
